import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface I_IndexReferencePointFormMeta {
    indexInstitutionId: FormInputMeta;
    indexInstitutionIdRefPoint: FormInputMeta;
    algo_indexBankId: FormInputMeta;
    algo_indexBankIdRefPoint: FormInputMeta;
    indexPanData: FormInputMeta;
    indexPanDataRefPoint: FormInputMeta;
    pinTrialTrack3: FormInputMeta;
    pinTrialTrack3RefPoint: FormInputMeta;
    dataPinOffset: FormInputMeta;
    dataPinOffsetRefPoint: FormInputMeta;
    indexCodeLanguage: FormInputMeta;
    indexCodeLanguageRefPoint: FormInputMeta;

}

const indexReferencePointFormMeta = {} as I_IndexReferencePointFormMeta;

indexReferencePointFormMeta.indexInstitutionId = {
    name: "indexInstitutionId",
    type: "number",
    label: "Index ID Institution",
    placeholder: "",
    validation: yup.number()
};

indexReferencePointFormMeta.indexInstitutionIdRefPoint = {
    name: "indexInstitutionIdRefPoint",
    type: "select",
    label: "Ref. Point",
    placeholder: "",
    validation: yup.string()
};

indexReferencePointFormMeta.algo_indexBankId = {
    name: "algo_indexBankId",
    type: "number",
    label: "Algorithme/Index ID Banque",
    placeholder: "",
    validation: yup.number()
};

indexReferencePointFormMeta.algo_indexBankIdRefPoint = {
    name: "algo_indexBankIdRefPoint",
    type: "select",
    label: "Ref. Point",
    placeholder: "",
    validation: yup.string()
};

indexReferencePointFormMeta.indexPanData = {
    name: "indexPanData",
    type: "number",
    label: "Index Données PAN",
    placeholder: "",
    validation: yup.number()
};

indexReferencePointFormMeta.indexPanDataRefPoint = {
    name: "indexPanDataRefPoint",
    type: "select",
    label: "Ref. Point",
    placeholder: "",
    validation: yup.string()
};

indexReferencePointFormMeta.pinTrialTrack3 = {
    name: "pinTrialTrack3",
    type: "number",
    label: "Essai PIN Piste 3",
    placeholder: "",
    validation: yup.number()
};

indexReferencePointFormMeta.pinTrialTrack3RefPoint = {
    name: "pinTrialTrack3RefPoint",
    type: "select",
    label: "Ref. Point",
    placeholder: "",
    validation: yup.string()
};

indexReferencePointFormMeta.dataPinOffset = {
    name: "dataPinOffset",
    type: "number",
    label: "PIN Offset Données",
    placeholder: "",
    validation: yup.number()
};

indexReferencePointFormMeta.dataPinOffsetRefPoint = {
    name: "dataPinOffsetRefPoint",
    type: "select",
    label: "Ref. Point",
    placeholder: "",
    validation: yup.string()
};

indexReferencePointFormMeta.indexCodeLanguage = {
    name: "indexCodeLanguage",
    type: "number",
    label: "Index Code Langage",
    placeholder: "",
    validation: yup.number()
};

indexReferencePointFormMeta.indexCodeLanguageRefPoint = {
    name: "indexCodeLanguageRefPoint",
    type: "select",
    label: "Ref. Point",
    placeholder: "",
    validation: yup.string()
};


export default indexReferencePointFormMeta;